import { Trans, useLingui } from '@lingui/react/macro';

import { FilterCheckboxItem } from '@/design_system/Filters/FiltersMenu/FilterCheckboxItem';
import { FiltersMenu, FiltersSubMenu } from '@/design_system/Filters/FiltersMenu/FiltersMenu';
import { FilterTag } from '@/design_system/Filters/FiltersMenu/FilterTag';
import IconTruck from '@/icons/Truck.svg';
import { SHIPMENT_CARRIERS_WITH_MORE_OPTIONS, useGetCarrierName } from '@/models/shipment';

import { useFilters } from '../FiltersState';

export const FiltersCarrier = ({ tag }: { tag?: boolean }) => {
  const { t } = useLingui();
  const getCarrierName = useGetCarrierName();

  const {
    carriers: { carriers, setCarriers },
  } = useFilters();

  const options = SHIPMENT_CARRIERS_WITH_MORE_OPTIONS.map((id) => (
    <FilterCheckboxItem
      key={id}
      checked={carriers.includes(id)}
      onChange={(checked) => {
        if (checked) {
          setCarriers([...carriers, id]);
        } else {
          setCarriers(carriers.filter((carrier) => carrier !== id));
        }
      }}
    >
      {getCarrierName(id)}
    </FilterCheckboxItem>
  ));

  if (tag) {
    if (carriers.length === 0) {
      return null;
    }

    return (
      <FiltersMenu
        button={
          <FilterTag
            label={t({ id: 'shipments.filters.carrier.label', message: 'Carrier' })}
            value={
              carriers.length === 1 ? (
                getCarrierName(carriers[0])
              ) : (
                <Trans id="shipments.filters.carrier.multiple">{carriers.length} carriers</Trans>
              )
            }
            tooltip={
              carriers.length > 1 ? carriers.map((id) => getCarrierName(id)).join(', ') : undefined
            }
            onClear={() => setCarriers([])}
          />
        }
      >
        {options}
      </FiltersMenu>
    );
  }

  return (
    <FiltersSubMenu
      icon={<IconTruck />}
      label={t({ id: 'shipments.filters.carrier.label', message: 'Carrier' })}
    >
      {options}
    </FiltersSubMenu>
  );
};
